export const isFirstChild = (path) => path[path.length - 1] === 0;
